import { create } from "zustand";

const useWaitingNewsStore = create((set) => ({
  selectedData: null,
  renewData: false,
  setSelectedData: (data) => set(() => ({ selectedData: data })),
  setRenewData: (bool) => set(() => ({ renewData: bool })),
}));

export default useWaitingNewsStore;
